import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop"; // 👈 Add this line
import Home from "./pages/Home";
import About from "./pages/About";
import Blog from "./pages/Blog";
import Team from "./pages/Team";
import Careers from "./pages/Careers";
import Contact from "./pages/Contact";
import Partners from "./pages/Partners";
import Accelerator from "./pages/Accelerator";
import Elevate from "./pages/Elevate";
import Footer from "./components/Footer";
import BlogPostPage from "./components/BlogPostPage"; // Adjust path if needed

const App = () => {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:id" element={<BlogPostPage />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/team" element={<Team />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/partners" element={<Partners />} />
        <Route path="/accelerator" element={<Accelerator />} />
        <Route path="/elevate" element={<Elevate />} />
      </Routes>
      <Footer />
    </Router>
  );
};

export default App;
